import SocialButton from 'components.v2/SocialButton/SocialButtonV2'
import withContainer from './SocialButtonContainer'

export default withContainer(SocialButton)
